import React from 'react';
import PropTypes from 'prop-types';
import Dictionary from '../../model/Dictionary';
import PassengersList from './PassengersList';
import { DialogContent, Button } from 'material-ui';
import MainController from '../../controllers/MainController';

const PassengersListWrapper = ({
  routeId,
  showOnlySelected,
  RowAction,
  onRowAction,
  onItemClickAction,
  selectable,
  selectedPassenger,
  addNew,
}) => (
  <div>
    <PassengersList
      routeId={routeId}
      activePassenger={selectedPassenger}
      showOnlySelected={showOnlySelected}
      onItemClickAction={onItemClickAction}
      RowAction={RowAction}
      onRowAction={onRowAction}
      selectable={selectable}
      addNew={addNew}
    />
  </div>
);

PassengersListWrapper.propTypes = {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  onItemClickAction: PropTypes.any,
  RowAction: PropTypes.any,
  onRowAction: PropTypes.any,
  selectable: PropTypes.bool,
  addNew: PropTypes.bool,
  selectedPassenger: PropTypes.string,
  showOnlySelected: PropTypes.bool,
};

export default PassengersListWrapper;



// WEBPACK FOOTER //
// ./src/containers/passengersList/PassengersListWrapper.js